// ##############################
// // // Constants
// #############################

// Redirecting route using domain, email and user Id
export const getRouteScreenPlayerUniverse = (domain, email, uid) =>
	`https://${domain}.visualid.com/admin/?e=${email}&id=${uid}`;

// Redirect to Admin User Details Page
export const getRouteAdminUserDetails = (domain, userId) =>
	`https://${domain}.visualid.com/admin/users/details/?id=${userId}`;
